/* eslint-disable */
//
// Shared API-error display (embeddable). Renders a catalogued API failure the SAME way
// everywhere: message headline, an optional "How to fix this" block with line breaks preserved,
// and a small click-to-copy error code. For toast-style failures use Common.showApiError; for
// inline surfaces (modal footers, result banners) use this component.
//
import React, { useState } from "react";

export default function ApiErrorNote({
  message,
  alternateMessage,
  errorCode,
  recoverySteps,
  className = "",
  compact = false,
  condensed = false,
}) {
  const [copied, setCopied] = useState(false);

  // `condensed` prefers the API's shorter alternateMessage when present; otherwise the full
  // message is the headline. alternateMessage may be null — always fall back to message.
  const headlineSource =
    condensed && typeof alternateMessage === "string" && alternateMessage.trim()
      ? alternateMessage
      : message;

  const hasSteps = typeof recoverySteps === "string" && recoverySteps.trim().length > 0;
  const hasCode = !!errorCode;
  const hasMessage = typeof headlineSource === "string" && headlineSource.trim().length > 0;
  // Fallback headline only applies when a headline is actually wanted (message provided). When
  // the caller passes an empty message (it already renders its own text), show no headline.
  const headline = hasMessage ? headlineSource : "An unexpected error occurred.";
  const showHeadline = hasMessage || (message !== "" && (hasSteps || hasCode));

  // Nothing catalogued at all → render nothing rather than an empty shell.
  if (!hasMessage && !hasSteps && !hasCode) return null;

  const copyCode = () => {
    const done = () => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(String(errorCode)).then(done).catch(done);
    } else {
      done();
    }
  };

  return (
    <div className={className}>
      {showHeadline && (
        <div className={compact ? "" : "font-weight-bold"}>{headline}</div>
      )}

      {/* Recovery steps — only when non-empty. pre-wrap preserves numbered steps' line breaks. */}
      {hasSteps && (
        <div className="mt-2 p-2 rounded" style={{ background: "#f3f6f9" }}>
          <div
            className="text-uppercase font-weight-bold text-muted mb-1"
            style={{ fontSize: "0.7rem", letterSpacing: "0.03em" }}
          >
            How to fix this
          </div>
          <div style={{ whiteSpace: "pre-wrap", fontSize: "0.9rem" }}>{recoverySteps}</div>
        </div>
      )}

      {/* Error code — small, muted, click-to-copy. Users quote this to support. */}
      {hasCode && (
        <div className="text-right mt-2">
          <small
            className="text-muted"
            style={{ cursor: "pointer" }}
            title="Click to copy"
            onClick={copyCode}
          >
            {errorCode} <i className="far fa-copy ml-1"></i>
            {copied && <span className="text-success ml-1">copied</span>}
          </small>
        </div>
      )}
    </div>
  );
}
